// extracted by mini-css-extract-plugin
module.exports = {"header":"AffiliateOwnerEditPage_header__xIt8V"};